(function (angular) {
    'use strict';

    angular.module('app')
        .service('EventAttendeesApi', eventAttendeesResource);

    eventAttendeesResource.$inject = [
        'settings',
        '$resource',
        'extendResource'
    ];

    function eventAttendeesResource(
        settings,
        $resource,
        extendResource
    ) {
        /**
         * Adds extra methods and values. Expects "this" to be bound to an event object
         * @return {this}
         */
        function transform() {

            return this;
        }

        // Create the resource
        var resource = $resource(settings.apiBase + '/event-attendees/:id', {
            id: '@id'
        }, {
            post: {
                method: 'POST',
                responseType: 'json'
            },
            get: {
                method: 'GET',
                responseType: 'json',
            },
            delete: {
                method: 'DELETE',
                responseType: 'json',
            }
        });
        resource.prototype.transform = transform;

        return extendResource(resource);
    }

}(angular));
